// extracted by mini-css-extract-plugin
module.exports = {"siteCard":"styles_siteCard__3PuNE"};